@if (loadError) {
  <!-- not a web address: never put in the frame -->
  <iu-widget-state state="error" (retry)="retryLoad()" />
} @else if (url) {
  @if (isLoading) {
    <div class="ghost-elt widget-ghost">
      <div class="ghost-rect widget-ghost-rect"></div>
    </div>
  }
  <iframe
    [src]="url"
    frameborder="0"
    width="100%"
    height="100%"
    allowtransparency
    referrerpolicy="no-referrer-when-downgrade"
    [hidden]="isLoading"
    (load)="onFrameLoad()"></iframe>
}
